import template from './utilities.html';
import { groupBy, property } from 'lodash-es';
import { STATES } from '../../../../constants';
import { ITEM_DEFINITION_CODES } from '../../../../constants/item-definitions';
import { actions, selectors } from '../../../../state';
import './utilities.global.css';
import { trackEngagement } from '@mover-app/engagement';

const EXCLUDED = 'EXCLUDED';
const NOT_FOUND = 'NOT_FOUND';

class UtilitiesController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      dashboardSref: STATES.DASHBOARD,
      haveUtilities: false,
    });
  }

  $onInit() {
    const { connect, dispatch } = this.updStore;
    dispatch(actions.step.isTerminalRoute());

    const success = ({ utilities, matches }) => {
      this.haveUtilities = utilities.length > 0;
      this.utilitiesExcluded = Object.values(matches).every(
        utility => utility.reason === EXCLUDED
      );
      this.utilitiesNotFound =
        !this.haveUtilities &&
        Object.values(matches).some(utility => utility.reason === NOT_FOUND);

      this.utilities = groupBy(utilities, 'kind');
    };

    const error = () => {
      this.utilities = {};
    };

    dispatch(actions.homeServices.read())
      .then(property('payload'))
      .then(mapJsonApiResponse)
      .then(success)
      .catch(error);

    this.disconnect = connect(mapStateToThis)(this);
    trackEngagement({
      code: ITEM_DEFINITION_CODES.UTILITY,
      name: 'Utilities',
    });
  }

  $onDestroy() {
    this.disconnect();
  }
}

export const UtilitiesComponent = {
  template,
  controller: UtilitiesController,
};

function mapStateToThis(state) {
  const siteConfig = selectors.current.siteConfig();
  const itemDefinition = selectors.itemDefinition.byCode(
    ITEM_DEFINITION_CODES['UTILITY']
  );

  return {
    loading: selectors.pending.match(actions.homeServices.isRead, state),
    entityName: siteConfig.divisionName(state) || siteConfig.companyName(state),
    hasBannerHtml: Boolean(itemDefinition.bannerHtml(state)),
  };
}

function mapJsonApiResponse({ data = [], meta: { matches = {} } }) {
  return {
    utilities: data.map(item => ({
      ...item.attributes,
      id: item.id,
    })),
    matches,
  };
}
